"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataArgs = void 0;
function getDataArgs(registration) {
    return registration === null || registration === void 0 ? void 0 : registration.dataDefinition;
}
exports.getDataArgs = getDataArgs;
//# sourceMappingURL=get-data-args.js.map